import * as React from "react";
const SvgLocation = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path fill="#fff" d="M0 0h20v20H0z" />
    <path
      stroke="#89909D"
      d="M10 11.075a2.34 2.34 0 1 0 0-4.682 2.34 2.34 0 0 0 0 4.682Z"
    />
    <path
      stroke="#89909D"
      d="M3.713 7.369C5.191.872 14.816.879 16.287 7.376c.862 3.811-1.508 7.037-3.586 9.032a3.896 3.896 0 0 1-5.41 0c-2.07-1.995-4.44-5.228-3.578-9.04Z"
    />
  </svg>
);
export default SvgLocation;
